import React, { PureComponent } from 'react'
import { Table, Alert } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { checkSession } from '../actions'
import { fetchBusinesses } from '../actions/businesses'
import { fetchAllBusinesses } from '../actions/businesses_all'
import { CustomPagination } from '../components/common/custom_pagination/custom_pagination'
import DropDownFilter from '../components/common/dropdown_filter'
import PageSizeFilter from '../components/common/page_size_filter'
import Spinner3Bounce from '../components/spinner_3_bounce'
import StatusLabelBusiness from '../components/status_label_business'
import CSVExport from '../components/csv_export'
import { resetCSVExport } from '../actions/csv_export'
import SearchBar from '../components/business/search_bar'
import CSVExporterFactory from '../managers/csv_export/csv_exporter_factory'
import { DivContentBox, DivTitleBox } from '../components/common/styled'
import {
  BUSINESS_TX_TABLE_SORT_CREATED,
  BUSINESS_TX_TABLE_SORT_NAME,
  BUSINESS_TX_TABLE_SORT_STATUS,
  disableBusinessTransactionSort,
  enableBusinessTransactionSort,
} from '../actions/business_tx_table_sort'
import SortData from '../models/sort_data'
import { formatTimeString } from '../utils/formatters'
import { addToSearch } from '../utils/helpers'
import { getSortDirection, getSortIcon } from '../utils/sort'

const defaultFilter = {
  pageSize: 20,
  search: '',
  status: '',
  business: '',
}
const defaultState = {}

const allStatuses = ['accepted', 'hold', 'open', 'rejected'].sort()
const defaultStatus = 'Status: No Filter'

export class Businesses extends PureComponent {
  static csvExportHeader = ['Business Name', 'Status', 'Created']
  static typeInvestor = 'investor'

  constructor(props) {
    super(props)
    this.handleSelectPage = this.handleSelectPage.bind(this)
    const params = this.getSearchParams()
    params.page = this.getActivePage()
    const filter = { ...{ ...defaultFilter }, ...params }
    this.state = {
      ...defaultState,
      filter,
    }
  }

  getSearchParams = () => {
    const search = window.location.search.substring(1)
    if (!search.length) {
      return {}
    }
    return JSON.parse(`{"${decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')}"}`)
  }

  handleSelectPage(page, metaKey) {
    const { state, props } = this
    const { fetchBusinesses, navigateToPage, sortField, sortOrder, navigateToPageInNewWindow } = props
    const { filter } = state
    let search = `?page=${page}`
    if (metaKey) {
      navigateToPageInNewWindow('', search || '')
    } else {
      fetchBusinesses(
        page,
        filter.pageSize,
        Businesses.typeInvestor,
        filter.search,
        filter.status,
        filter.business,
        new SortData(sortField, sortOrder)
      )
      navigateToPage('', search || '')
    }
  }

  componentDidMount() {
    const { state, props } = this
    const { fetchBusinesses, checkSession, sortField, sortOrder, fetchAllBusinesses } = props
    const { filter } = state
    checkSession()
    fetchAllBusinesses()
    fetchBusinesses(
      filter.page,
      filter.pageSize,
      Businesses.typeInvestor,
      filter.search,
      filter.status,
      filter.business,
      new SortData(sortField, sortOrder)
    )
  }

  handleTableSort = (field) => {
    const { state, props } = this
    const { sortField, sortOrder, fetchBusinesses, enableBusinessTransactionSort, disableBusinessTransactionSort } =
      props

    const sortDirection = getSortDirection(sortOrder, sortField, field)
    const { filter } = state
    if (sortDirection) {
      enableBusinessTransactionSort(field, sortDirection)
    } else {
      disableBusinessTransactionSort()
      field = null
    }
    fetchBusinesses(
      filter.page,
      filter.pageSize,
      Businesses.typeInvestor,
      filter.search,
      filter.status,
      filter.business,
      new SortData(field, sortDirection)
    )
  }

  getActivePage() {
    const { location } = this.props
    if (location && location.search.indexOf('page=') !== -1) {
      return parseInt(location.search.split('page=').pop(), 0)
    }
    return 1
  }

  updateFilter = (event) => {
    const { state, props } = this
    const { navigateToPage, sortField, sortOrder, fetchBusinesses } = props
    let filter = { ...state.filter, ...event }
    this.setState({ filter })
    const { pageSize, search, status, business } = filter

    let searchString = '?page=' + 1
    if (pageSize) {
      searchString = addToSearch(searchString, `pageSize=${pageSize}`)
    }

    if (search) {
      searchString = addToSearch(searchString, `search=${search}`)
    }
    if (status) {
      searchString = addToSearch(searchString, `status=${status}`)
    }
    if (business) {
      searchString = addToSearch(searchString, `business=${business}`)
    }
    navigateToPage('', searchString || '')
    fetchBusinesses(
      1,
      filter.pageSize,
      Businesses.typeInvestor,
      filter.search,
      filter.status,
      filter.business,
      new SortData(sortField, sortOrder)
    )
  }

  render() {
    const { state, updateFilter } = this
    const activePage = this.getActivePage()
    const { results, errorMessage, isAuthenticated, isFetching, requestUrl, count, sortField, sortOrder } = this.props

    if (!isAuthenticated) {
      return null
    }

    if (isFetching) {
      return (
        <div className='text-center grid-spinner-mt-240'>
          <Spinner3Bounce isActive />
        </div>
      )
    }
    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <DivTitleBox className='ibox-title'>
          <div className='row'>
            <div className='col-xs-6 col-sm-4'>
              <SearchBar filter={state.filter.search} updateFilter={updateFilter} />
            </div>
            <div className='col-xs-6 col-sm-4'>
              <DropDownFilter
                defaultValue={defaultStatus}
                values={allStatuses}
                filter={state.filter.status}
                updateFilter={updateFilter}
              />
            </div>
            <div className='col-xs-6 col-sm-2'>
              <PageSizeFilter updateFilter={updateFilter} filter={parseInt(state.filter.pageSize)} />
            </div>
            <div className='col-xs-6 col-sm-2 text-end'>
              <CSVExport
                exporter={CSVExporterFactory.BUSINESS}
                header={Businesses.csvExportHeader}
                count={count}
                url={requestUrl}
              />
            </div>
          </div>
        </DivTitleBox>
        <DivContentBox className='ibox-content'>
          <div>
            {errorMessage && <Alert variant='danger'>{errorMessage}</Alert>}
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th
                    className='cursor-pointer td-nowrap'
                    onClick={() => this.handleTableSort(BUSINESS_TX_TABLE_SORT_NAME)}
                  >
                    <div>
                      <div style={{ float: 'left' }}>Business Name</div>
                      {getSortIcon(sortOrder, sortField, BUSINESS_TX_TABLE_SORT_NAME)}
                    </div>
                  </th>
                  <th
                    className='cursor-pointer td-nowrap'
                    onClick={() => this.handleTableSort(BUSINESS_TX_TABLE_SORT_STATUS)}
                  >
                    <div style={{ float: 'left' }}>Status</div>
                    {getSortIcon(sortOrder, sortField, BUSINESS_TX_TABLE_SORT_STATUS)}
                  </th>
                  <th
                    className='cursor-pointer td-nowrap'
                    onClick={() => this.handleTableSort(BUSINESS_TX_TABLE_SORT_CREATED)}
                  >
                    <div style={{ float: 'left' }}>Created</div>
                    {getSortIcon(sortOrder, sortField, BUSINESS_TX_TABLE_SORT_CREATED)}
                  </th>
                </tr>
              </thead>
              <tbody>
                {results &&
                  results.map((business) =>
                    results ? (
                      <tr
                        key={business.id}
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.props.viewBusiness(business.id)}
                      >
                        <td>{business.name}</td>
                        <td>
                          <StatusLabelBusiness state={business.status} />
                        </td>
                        <td>{formatTimeString(business.created)}</td>
                      </tr>
                    ) : (
                      <tr key={business.id}>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                      </tr>
                    )
                  )}
              </tbody>
            </Table>
            <div className='text-center'>
              <CustomPagination
                activePage={activePage}
                onPageChanged={this.handleSelectPage}
                totalRecords={this.props.count}
                pageLimit={state.filter.pageSize}
              />
            </div>
          </div>
        </DivContentBox>
      </div>
    )
  }
}
const mapStateToProps = (state, ownProps) => ({
  isAuthenticated: state.auth.isAuthenticated,
  errorMessage: state.businesses.errorMessage,
  results: state.businesses.results,
  isFetching: state.businesses.isFetching,
  count: state.businesses.count,
  nextUrl: state.businesses.nextUrl,
  pageHash: ownProps.location.hash,
  requestUrl: state.businesses.requestUrl,
  sortField: state.businessTransactionSort.sortField,
  sortOrder: state.businessTransactionSort.order,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      fetchBusinesses,
      fetchAllBusinesses,
      checkSession,
      resetCSVExport,
      enableBusinessTransactionSort,
      disableBusinessTransactionSort,
      viewBusiness: (id) => ownProps.history.push(`/business/${id}`),
      navigateToPage: (p, s) => ownProps.history.push({ pathname: '/businesses', search: s || '' }),
      navigateToPageInNewWindow: (p, s) => {
        window.open(`/businesses${s}`, '_blank')
      },
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Businesses))
